import {
  Box,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import CommonService from "services/CommonService";
import RoleService from "services/RoleService";
import { AuthData } from "auth/AuthWarpper";
import { useLocation, useNavigate } from "react-router-dom";
import { SnackbarContext } from "context/snackBarContext";
import LayoutAccessManagement from "components/structure/LayoutAccessManagement";
import Delegation from "assets/delegation.svg";

const DelegationUi = () => {
  const location = useLocation();
  const { fromUrl } = location.state || {};
  const profileOptions = ["Global", "Local"];
  const { user } = AuthData();
  const navigate = useNavigate();
  const { setOpenAlert, setSeverity, setMessage, handleClose } =
    useContext(SnackbarContext);

  const [formData, setFormData] = useState({
    profile: "",
    fieldTechnician: "",
    role: "",
    country: "",
    serviceNumber: "",
    remarks: "",
  });
  const [selected, setSelected] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = React.useState(false);

  const [roleOptions, setRoleOptions] = useState([]);
  const [countries, setCountries] = useState([]);

  const fetchRoles = async () => {
    try {
      const response = await RoleService.getActiveRoles();
      if (response.data?.statusCode === 200) {
        setRoleOptions(response.data.response);
      } else {
        console.error("Error fetching roles:", response.data.message);
      }
    } catch (error) {
      console.error("API call error:", error);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await CommonService.fetchCountries();
      if (response.data?.statusCode === 200) {
        setCountries(response.data.response);
      } else {
        console.error("Error fetching roles:", response.data.message);
      }
    } catch (error) {
      console.error("API call error:", error);
    }
  };

  useEffect(() => {
    fetchRoles();
    fetchCountries();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const isAllSelected =
    countries.length > 0 && selected.length === countries.length;

  const handleChangeCountry = (event) => {
    const option = event.target.value;

    if (option[option.length - 1] === "all") {
      setSelected(selected.length === countries.length ? [] : countries);
      // Update formData to reflect selected or deselected countries
      setFormData((prevFormData) => ({
        ...prevFormData,
        cropStageCountryDetail:
          selected.length === countries.length ? [] : countries,
      }));
      return;
    }

    setSelected(option);
    setFormData((prevFormData) => ({
      ...prevFormData,
      cropStageCountryDetail: option,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // setErrors({});
      // await validationSchema.validate(formData, { abortEarly: false });

      // Constructing the payload object
      const payload = {
        profileName: formData.fieldTechnician,
        isActive: true,
        profileAttribute: formData.profile,
        serviceNumber: formData.serviceNumber,
        remarks: formData.remarks,
        isDeleted: false,
        profileOwnerId: formData.role,
        systemOwner: user?.batOneId,
        countries: selected.map((country) => ({
          createdByUser: user?.userName || "Raju",
          modifiedByUser: user?.userName || "Raju",
          countryCode: country.countryCode,
          isDeleted: false,
          createdDateTimeUTC: new Date().toISOString(),
          modifiedDateTimeUTC: new Date().toISOString(),
        })),
        createdByUser: user.userName,
        modifiedByUser: user.userName,
        createdDateTimeUTC: new Date().toISOString(),
        modifiedDateTimeUTC: new Date().toISOString(),
      };

      // Make a POST request using Axios
      const response = await RoleService.createRole(payload);
      setLoading(false);

      if (response.status === 201) {
        // Show success snackbar
        navigate("/roleCreation");
        setSeverity("success");
        setMessage("Added successfully");
        setOpenAlert(true);
        setLoading(false);
      } else {
        console.error("Failed to submit form");
        // Show error snackbar
        setSeverity("error");
        setMessage("Failed to submit form");
        setOpenAlert(true);
      }
    } catch (error) {
      setLoading(false);
      let newError = {};
      if (error?.name && error.name === "ValidationError") {
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
          setErrors(newError || error?.message);
          return;
        });
      } else {
        setSeverity("error");
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
      }
    }
  };
  return (
    <LayoutAccessManagement>
      <Box sx={{ paddingBottom: "150px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "65vh",
            background: "#f0f3f6",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            padding: "25px",
            borderRadius: "6px",
            gap: "60px",
          }}
        >
          {fromUrl == 'RoleAssignList' || fromUrl == 'administratorUserList' || fromUrl == 'administratorCreation' ?
            <Box
              // onClick={() => navigate('/selfDelegation',{ state: { fromUrl: fromUrl}})}
              onClick={() => navigate('/selfDelegationList', { state: { fromUrl: fromUrl } })}
              sx={{
                background: "#ffffff",
                width: "280px",
                height: "402px",
                p: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "15px",
                borderRadius: "16px",
                transition: "box-shadow 0.3s ease-in-out",
                "&:hover": {
                  boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                },
                cursor: "pointer"

              }}
            >
              <img
                src={Delegation}
                style={{ width: "100px", height: "100px" }}
                alt="List Logo"
              />
              <Typography
                sx={{ fontWeight: 600, fontSize: "40px", color: "#0A3575", textAlign: "center" }}
              >
                Self Delegation
              </Typography>
            </Box>
            : ""
          }
          {/* {fromUrl == 'userCreation' || fromUrl ==  'administratorUserList' ? */}
          {fromUrl == 'userCreation' || fromUrl == 'roleCreation' ?
            <Box
              onClick={() => navigate('/otherDelegation', { state: { fromUrl: fromUrl } })}
              sx={{
                background: "#ffffff",
                width: "280px",
                height: "402px",
                p: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "15px",
                borderRadius: "16px",
                transition: "box-shadow 0.3s ease-in-out",
                "&:hover": {
                  boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                },
                cursor: "pointer"
              }}
            >
              <img
                src={Delegation}
                style={{ width: "100px", height: "100px" }}
                alt="List Logo"
              />
              <Typography
                sx={{ fontWeight: 600, fontSize: "40px", color: "#0A3575", textAlign: "center" }}
              >
                Other Delegation
              </Typography>
            </Box>
            : ""
          }
        </Box>
      </Box>
    </LayoutAccessManagement>
  );
};

export default DelegationUi;
